import { SearchModalPage } from './search-modal/search.modal.page';
import { DevicedialogComponent } from './component/devicedialog/devicedialog.component';
import { WebdialogComponent } from './component/webdialog/webdialog.component';
import { ContactModalPage } from './contact-modal/contact.modal.page';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { ProductModalPage } from './product-modal/product.modal.page';


import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { UserModalPage } from './user-modal/user.modal.page';
import { FCM } from '@ionic-native/fcm/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { Camera } from '@ionic-native/Camera/ngx';
import { CKEditorModule } from 'ng2-ckeditor';
import { DatePipe } from '@angular/common';
import { PopupComponent } from './popup/popup.component';
// import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// import { Pro } from '@ionic/pro';

// Pro.init('e4a69a8e', {
//   appVersion: '0.0.9'
// });
@NgModule({
  declarations: [
    AppComponent,
    ProductModalPage,
    ContactModalPage,
    UserModalPage,
    WebdialogComponent,
    DevicedialogComponent,
    SearchModalPage,
    PopupComponent

  ],
  entryComponents: [
    ProductModalPage,
    ContactModalPage,
    UserModalPage,
    WebdialogComponent,
    DevicedialogComponent,
    SearchModalPage,
    PopupComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    IonicStorageModule.forRoot(),
  ],
  providers: [
    SplashScreen,
    FCM,
    DatePipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    File,
    FileOpener,
    SocialSharing,
    // tslint:disable-next-line: deprecation
    FileTransfer,
    DocumentViewer,
    Geolocation,
    NativeGeocoder,
    Camera
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
